import { useEffect, useState } from "react";
import api from "../../lib/api";
import { InvoiceImages } from "./InvoiceImages";
import { fmtCur, fmtIDR, fmtNum, inp, toastErr } from "./util";

export default function InvoiceList({ onOpen }) {
    const [q, setQ] = useState("");
    const [field, setField] = useState("date");
    const [order, setOrder] = useState("desc");
    const [rows, setRows] = useState(null);
    useEffect(() => {
        const t = setTimeout(() => {
            api.get("/invoices", { params: { q, order: field === "date" ? order : "desc", field: field === "date" ? undefined : field } }).then(({ data }) => setRows(data)).catch((e) => toastErr(e, "Failed to load invoices"));
        }, 250);
        return () => clearTimeout(t);
    }, [q, field, order]);
    const ph = { date: "Search supplier, invoice no., SKU", supplier: "Search supplier", invoice_no: "Search invoice no.", sku: "Search SKU" }[field];
    return (
        <div className="space-y-3" data-testid="invoice-list">
            <input className={inp} placeholder={ph} value={q} onChange={(e) => setQ(e.target.value)} data-testid="invoice-search" />
            <div className="grid grid-cols-2 gap-2 text-[10px] uppercase text-neutral-400">
                <label>Filter By<select className={inp} value={field} onChange={(e) => setField(e.target.value)} data-testid="invoice-filter-by"><option value="date">Purchase Date</option><option value="supplier">Supplier</option><option value="invoice_no">Invoice No.</option><option value="sku">SKU</option></select></label>
                {field === "date" && <label>Sort<select className={inp} value={order} onChange={(e) => setOrder(e.target.value)} data-testid="invoice-sort"><option value="desc">Newest First</option><option value="asc">Oldest First</option></select></label>}
            </div>
            {rows && rows.length === 0 && <p className="text-sm text-neutral-400">No invoices yet.</p>}
            <div className="space-y-2">
                {(rows || []).map((r) => (
                    <div key={r.id} className="border border-mist rounded-sm bg-white p-3 flex flex-wrap items-center justify-between gap-2" data-testid={`invoice-row-${r.id}`}>
                        <button type="button" className="text-left min-w-0 flex-1" onClick={() => onOpen(r.id)} data-testid={`invoice-open-${r.id}`}>
                            <div className="text-sm font-medium text-ink" data-testid={`invoice-row-date-${r.id}`}>{r.invoice_date}</div>
                            <div className="text-sm font-semibold text-sage-dark break-words" data-testid={`invoice-row-supplier-${r.id}`}>{r.supplier_name}</div>
                            <div className="text-xs text-neutral-500 space-y-0.5 mt-0.5">
                                <div>{r.invoice_number || "No invoice no."} · {fmtNum(r.items_qty)} pcs</div>
                                <div>Total {fmtCur(r.currency, r.items_total)}</div>
                                <div>Total Cost {fmtIDR(r.items_total_idr)}</div>
                                {r.printed_total != null && <div>Invoice Total {fmtCur(r.currency, r.printed_total)}</div>}
                                {r.final_paid != null && <div>Paid {fmtCur(r.currency, r.final_paid)}</div>}
                            </div>
                        </button>
                        <InvoiceImages fileIds={r.file_ids} testid={`invoice-row-original-${r.id}`} />
                    </div>
                ))}
            </div>
        </div>
    );
}
